import React from 'react';
import './RegionMarketStatsTable.css';

function formatIsk(value) {
  if (value == null || value === 0) return '0 ISK';
  const abs = Math.abs(value);
  if (abs >= 1e12) return (value / 1e12).toFixed(2) + 'T ISK';
  if (abs >= 1e9) return (value / 1e9).toFixed(2) + 'B ISK';
  if (abs >= 1e6) return (value / 1e6).toFixed(2) + 'M ISK';
  if (abs >= 1e3) return (value / 1e3).toFixed(1) + 'K ISK';
  return Math.round(value).toLocaleString() + ' ISK';
}

function formatVolume(value) {
  if (value == null) return '—';
  return Math.round(value).toLocaleString();
}

const COLUMNS = [
  { key: 'type_name', label: 'Item Name' },
  { key: 'avg_volume', label: 'Avg Daily Volume' },
  { key: 'avg_isk_per_day', label: 'Avg Daily ISK' },
  { key: 'avg_order_count', label: 'Avg Daily Orders' },
  { key: 'last_trade_date', label: 'Last Traded' },
];

export default function RegionMarketStatsTable({
  data,
  sort,
  search,
  page,
  loading,
  onSearch,
  onSort,
  onPageChange,
}) {
  const { results = [], total = 0, pages = 0 } = data || {};

  const sortArrow = col => {
    if (sort.col !== col) return <span className="sort-arrow sort-arrow--inactive">↕</span>;
    return <span className="sort-arrow">{sort.order === 'asc' ? '↑' : '↓'}</span>;
  };

  return (
    <div className="rms-table-wrapper">
      <div className="toolbar">
        <input
          type="text"
          className="rms-search-input"
          placeholder="Search item name…"
          value={search}
          onChange={e => onSearch(e.target.value)}
        />
        <span className="rms-total-count">{total.toLocaleString()} items</span>
      </div>

      <div className="table-scroll">
        <table className="data-table rms-table">
          <thead>
            <tr>
              {COLUMNS.map(col => (
                <th
                  key={col.key}
                  className="rms-th sortable"
                  onClick={() => onSort(col.key)}
                >
                  {col.label} {sortArrow(col.key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={COLUMNS.length} className="rms-loading-cell">Loading…</td>
              </tr>
            ) : results.length === 0 ? (
              <tr>
                <td colSpan={COLUMNS.length} className="rms-empty-cell">No results found.</td>
              </tr>
            ) : (
              results.map(row => (
                <tr
                  key={row.type_id}
                  className={`rms-row${row.is_seeding_item ? ' rms-row--seeding' : ''}`}
                >
                  <td className="rms-td rms-td--name">
                    {row.type_name}
                    {row.is_seeding_item && <span className="rms-seeding-badge">seeding</span>}
                  </td>
                  <td className="rms-td rms-td--number">{formatVolume(row.avg_volume)}</td>
                  <td className="rms-td rms-td--number">{formatIsk(row.avg_isk_per_day)}</td>
                  <td className="rms-td rms-td--number">{formatVolume(row.avg_order_count)}</td>
                  <td className="rms-td rms-td--date">{row.last_trade_date || '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pages > 1 && (
        <div className="pager">
          <button
            className="btn btn-sm"
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1 || loading}
          >
            Previous
          </button>
          <span className="rms-page-info">Page {page} of {pages}</span>
          <button
            className="btn btn-sm"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= pages || loading}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
